import { BrowserRouter as Router } from 'react-router-dom';
import React, { useContext } from 'react';
import Routes from '../Routes';
import { Layout } from 'antd';
import LayoutFooter from './Footer';
import LayoutHeader from './Header';
import { UserContext } from '../Context/UserContext';
import Sidebar from './Sidebar';
import { ThemeContext } from '../Context/ThemeContext';

const { Content } = Layout;

function Layouts(){
    const [user] = useContext(UserContext)
    const [,,dashboard] = useContext(UserContext)
    const [theme] = useContext(ThemeContext)

    const changeNameClass =  theme === 'dark' ? 'dark-nav' : theme === 'light' ? 'light-nav': ''
    return (
        <Router>
            <Layout style={{ minHeight: "100vh"}}>
                <LayoutHeader/>
                <Content className={changeNameClass}>
                    <Layout className={"site-layout-background " + changeNameClass}>
                    {user && dashboard &&  <Sidebar/> }
                    <Content className={changeNameClass}
                        style={{
                        padding: '0 24px',
                        minHeight: 280,
                        }}
                    >
                    <Routes/>
                    </Content>
                    </Layout>
                </Content>
                <LayoutFooter className={changeNameClass}/>
            </Layout>
        </Router>
    )
}

export default Layouts